// extracted by mini-css-extract-plugin
export default {"removePermissionButton":"removePermissionButton---uNie2","removePermissionIcon":"removePermissionIcon---sEH2Y"};